if (!customElements.get('tpt-review-5-container')) {
  customElements.define(
    'tpt-review-5-container',
    class TptReview5Container extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.cards = this.querySelectorAll('.tpt-review-5-card.tpt-review-5-real');
        this.headerSub = this.querySelector('.tpt-section-header_sub-heading');
        this.headerTitle = this.querySelector('.tpt-section-header_title');
        this.headerDes = this.querySelector('.tpt-section-header_description > p');
        this.defaultDes = this.headerDes ? this.headerDes.textContent : '';

        if (!this.cards.length || !this.headerSub || !this.headerTitle) return;

        // save default content
        this.defaultSub = this.headerSub.textContent;
        this.defaultTitle = this.headerTitle.textContent;

        // click card
        this.cards.forEach((card) => {
          card.addEventListener('click', (e) => {
            e.stopPropagation();
            this.activateCard(card);
          });
        });

        // click outsite
        document.addEventListener('click', (e) => {
            if (e.target.closest('.tpt-section-header')) {
                return;
            }
            if (!e.target.closest('.tpt-review-5-card')) {
                this.resetCards();
            }
        });
      }

      activateCard(card) {
        const handle = card.dataset.handle || '';
        const quote = card.dataset.quote || '';
        const isVerified = card.dataset.verified == 'true';
        const rating = parseFloat(card.dataset.rating) || 0;

        // update header content
        this.headerSub.classList.add('is-active');
        this.headerTitle.classList.add('is-active');
        this.headerSub.textContent = handle;
        this.headerTitle.textContent = quote;
        if (this.headerDes) this.headerDes.textContent = '';

        const oldBadge = this.headerSub.parentElement.querySelector('.tpt-review-5-verified-badge');
        if (oldBadge) oldBadge.remove();

        const oldRating = this.headerTitle.parentElement.querySelector('.tpt-review-5-rating');
        if (oldRating) oldRating.remove();

        // add verified badge if applicable
        if (isVerified) {
          const badge = document.createElement('div');
          badge.className = 'tpt-review-5-verified-badge';
          badge.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20" height="20" viewBox="0 0 90 90" xml:space="preserve">
            <polygon points="45,6.18 57.06,0 64.41,11.38 77.94,12.06 78.62,25.59 90,32.94 83.82,45 90,57.06 78.62,64.41 77.94,77.94 64.41,78.62 57.06,90 45,83.82 32.94,90 25.59,78.62 12.06,77.94 11.38,64.41 0,57.06 6.18,45 0,32.94 11.38,25.59 12.06,12.06 25.59,11.38 32.94,0 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(126,217,87); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
                <polygon points="40.16,58.47 26.24,45.08 29.7,41.48 40.15,51.52 61.22,31.08 64.7,34.67 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
            </svg>
            <span>Verified User</span>
          `;
          this.headerSub.insertAdjacentElement('afterend', badge);
        }

        if (rating) {
            const badge = document.createElement('div');
            badge.className = 'tpt-review-5-rating';

            let html = '';
            for (let i = 1; i <= 5; i++) {
                if (i <= rating) {
                    // full star
                    html += `<span class="tpt-review-5-star active">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                            </span>`;
                } else if (i - 0.5 <= rating) {
                    // half star
                    html += `<span class="tpt-review-5-star half-active">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                            </span>`;
                } else {
                    // empty star
                    html += `<span class="tpt-review-5-star">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                </svg>
                            </span>`;
                }
            }

            badge.innerHTML = html;
            this.headerTitle.insertAdjacentElement('afterend', badge);
        }


        // update class
        this.cards.forEach((c) => {
          if (c === card) {
            c.classList.add('is-active');
            c.classList.remove('no-active');
          } else {
            c.classList.remove('is-active');
            c.classList.add('no-active');
          }
        });
      }

      resetCards() {
        // reset class
        this.cards.forEach((c) => c.classList.remove('is-active', 'no-active'));

        // reset header content
        this.headerSub.classList.remove('is-active');
        this.headerTitle.classList.remove('is-active');
        this.headerSub.textContent = this.defaultSub;
        this.headerTitle.textContent = this.defaultTitle;
        if (this.headerDes) this.headerDes.textContent = this.defaultDes;

        const oldBadge = this.headerSub.parentElement.querySelector('.tpt-review-5-verified-badge');
        if (oldBadge) oldBadge.remove();

        const oldRating = this.headerTitle.parentElement.querySelector('.tpt-review-5-rating');
        if (oldRating) oldRating.remove();
      }
    }
  );
}
